module.exports = __webpack_public_path__ + "img/homeBg2.666c8b7a.png";